<template>
    <div class="flex justify-center items-center w-full">
        <span 
            v-for="n in numFullStars"
            :key="'full-stars-' + n"
            :class="svgSizeClasses(['star-rating full'])"
        ></span>

        <span 
            v-for="n in numHalfStars"
            :key="'half-stars-' + n"
            :class="svgSizeClasses(['star-rating half'])"
        ></span>

        <span 
            v-for="n in numEmptyStars"
            :key="'empty-stars-' + n"
            :class="svgSizeClasses(['star-rating empty'])"
        ></span>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'

    export default {
        props: ["rating", "size", "cursor"],

        data() {
            return {
            }
        },

        computed: {
            ...mapGetters("general",[
                'getUrl',
            ]),
            mouseCursor() {
        		return this.cursor;
        	},
        	numFullStars() {
        		return Math.floor(this.rating);
        	},
        	numHalfStars() {
        		let leftHalf = Math.ceil(this.rating - this.numFullStars);

        		return leftHalf;
        	},
        	numEmptyStars() {
        		let leftHollow = 5 - this.numFullStars - this.numHalfStars;

        		return leftHollow;
        	},
        },

        methods: {
        	svgSizeClasses(classes, flipped = false) {
                classes.push('h-' + this.size);
                classes.push('w-' + this.size);

        		if(flipped) { // Dummy for webpack: class="-ml-4 -ml-5 -ml-6 -ml-7 -ml-8"
					classes.push('-ml-' + this.size);
        		}

        		return classes.join(' ');
        	}

        }
    }
</script>
